import { useQuery } from '@tanstack/react-query';
import { getProjectCountChartData } from 'services/reactQueryservices';
import { projectCountChartDataKey } from 'react_query/query-keys';

const useProjectCountChartData = () => {
    const { data, isFetching, error } = useQuery({
        queryKey: [projectCountChartDataKey],
        queryFn: () => getProjectCountChartData()
    });

    return {
        data,
        isFetching,
        error
    };
}

export default useProjectCountChartData;
